import { Component, ElementRef, forwardRef, OnDestroy, OnInit, Renderer2, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, Credentials } from 'app/core/index';
import { NotificationsService } from '@app/core/notifications.service';
import { PusherService } from '@app/core/pusher.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.template.html',
  styleUrls: ['./notifications-modal.template.scss'],
  animations: [],
})
export class NotificationsModalComponent implements OnInit, OnDestroy {
  notifications: any = [];
  userInfo$: Subscription = null;

  constructor(
    private router: Router,
    private pusher: PusherService,
    private notificationsService: NotificationsService,
    private auth: AuthenticationService
  ) {
    // super(elemRef, renderer);
  }

  public ngOnInit() {
    this.userInfo$ = this.auth.userInfo$.subscribe(
      (user: any) => {
        if (user && user._id) {
          this.getNotifications();
        }
      },
      () => {}
    );
  }

  public ngOnDestroy() {
    if (this.userInfo$) {
      this.userInfo$.unsubscribe();
    }
  }

  getNotifications() {
    this.notificationsService.get().then((data: any) => {
      this.notifications = data
        .map(item => {
          item.text = this.notificationsService.textBuilder(item);
          return item;
        })
        .filter(item => {
          return item.text !== null;
        });
    });
  }

  notificationMark(id: string) {
    if (this.notifications.filter((item: any) => item._id === id)[0].seenAt) return;
    this.notificationsService.markAsRead(id).then((data: any) => {
      this.notifications.filter((item: any) => item._id === id)[0].seenAt = new Date();
    });
  }

  close() {
    this.router.navigate(['/', { outlets: { modal: null } }]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/notifications/notifications-modal.component.ts